import type { NotificationListResponse, NotificationUnreadCount } from '@warehouse/shared';

import { api } from '../../../lib/api-client';
import { listQueryKey, listQueryParams, type ListState } from '../../../lib/list-query';

/**
 * The notification centre's fetch layer. Both chromes use it: the bell in the
 * header and the full page under `/notifications` (admin) and
 * `/portal/notifications`.
 */

export const notificationKeys = {
  all: ['notifications'] as const,
  list: (state: ListState) => ['notifications', 'list', listQueryKey(state)] as const,
  unread: () => ['notifications', 'unread'] as const,
};

export function fetchNotifications(state: ListState): Promise<NotificationListResponse> {
  return api.get<NotificationListResponse>('/notifications', { query: listQueryParams(state) });
}

export function fetchUnreadCount(): Promise<NotificationUnreadCount> {
  return api.get<NotificationUnreadCount>('/notifications/unread-count');
}

export function markNotificationRead(id: string): Promise<NotificationUnreadCount> {
  return api.post<NotificationUnreadCount>(`/notifications/${id}/read`);
}

export function markAllNotificationsRead(): Promise<NotificationUnreadCount> {
  return api.post<NotificationUnreadCount>('/notifications/read-all', {
    until: new Date().toISOString(),
  });
}
